import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapCardWithCustomlist = React.lazy(function () {
    return import('../../bootstrap-components/components/BTCardWithCustomList');
});
var bootStrapCardWithCustomlist = function (props) {
    return (React.createElement(BootStrapCardWithCustomlist, __assign({}, props)));
};
var CardWithCustomlist = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapCardWithCustomlist(props);
            break;
        default:
            componentToDisplay = bootStrapCardWithCustomlist(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
CardWithCustomlist.defaultProps = {
    styleName: 'primary',
    name: 'CardWithCustomlist',
    ioTheme: themes[0],
    ioMode: 'light',
};
export default CardWithCustomlist;
//# sourceMappingURL=CardWithCustomList.js.map